"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.moment = exports.default = void 0;
var DateHelper_1 = require("./DateHelper");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return __importDefault(DateHelper_1).default; } });
var moment_1 = require("moment");
Object.defineProperty(exports, "moment", { enumerable: true, get: function () { return __importDefault(moment_1).default; } });
//# sourceMappingURL=index.js.map